const layout = () => import(/* webpackChunkName: "layout" */ '@/components/layout');

export default [
  {
    path: '',
    component: layout,
    children: [
      {
        name: 'goodsDetails',
        component: () => import(/* webpackChunkName: "b2b_goods_details" */ '@/pages/goodsDetails'),
        meta: {
          title: '商品详情'
        },
        path: '/goodsDetails/:id'
      }
    ]
  }
];
